import { PropsWithChildren } from 'react';

import { ContentStyled } from './Content.styles';

export const Content = ({ children }: PropsWithChildren) => (
  <ContentStyled as="section">{children}</ContentStyled>
);
